import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicingContent } from 'app/servicing/types/servicing-content.model';
import { environment } from 'environments/environment';
import { MetafrenzyService } from 'ngx-metafrenzy';

@Component({
  selector: 'app-content-servicing',
  templateUrl: './content-servicing.component.html',
  styleUrls: ['./content-servicing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContentServicingComponent implements OnInit {
  content: any;
  source: string;
  url = '';
  searchContent = '';

  urlLogin = `${environment.appUrl}/auth/login`;
  urlSignUp = `${environment.appUrl}/auth/signup`;
  wipperozLogo =
    'https://cdn.sanity.io/images/jizm7zxy/production/eca04a468bb51fd5165d6e25cd62302a3aa3cf7e-300x117.png?fm=webp&q=60&w=200';

  constructor(private route: ActivatedRoute, private readonly metafrenzyService: MetafrenzyService) {}

  ngOnInit(): void {
    this.url = `${environment.landingUrl}/${this.route.snapshot.url.join('/')}`;
    this.content = this.route.snapshot.data.data.servicingContent as ServicingContent;
    const title = $localize`:@@servicingTitleMetaTag:Servicing | Wipperoz -`;
    this.metafrenzyService.setTitle(`${title} ${this.content.contentTitle}`);
    this.metafrenzyService.setTags(this.content.contentTags);
    this.metafrenzyService.setMetaTag('description', this.content.contentDescription);
    this.metafrenzyService.setMetaTag('og:title', this.content.contentTitle);
    this.metafrenzyService.setMetaTag('og:description', this.content.contentDescription);
    this.metafrenzyService.setMetaTag('twitter:title', this.content.contentTitle);
    this.metafrenzyService.setMetaTag('twitter:description', this.content.contentDescription);
    this.metafrenzyService.setMetaTag('image', this.content.featureImageUrl);
    this.metafrenzyService.setMetaTag('twitter:image', this.content.featureImageUrl);
    this.metafrenzyService.setMetaTag('og:image', this.content.ogImageUrl);
  }
}
